import './App.less';
import ContactUs from './Model/ConatctUs';
import Footer from './Model/Footer';
import Header from './Model/Header';
import Testimonials from './Model/Testimonials';
import logo from './logo.jpeg';
import { useNavigate } from 'react-router-dom';
import ImageShow from './Model/ImageShow';
import LeftCard from './Model/leftSideBox';
import RightCard from './Model/RightSideBox';


function KnowBuild() {
  const navigate = useNavigate();
  const headerConfig = {
    logo,
    brand: 'Aspire Homes',
    menuItems: [
      { name: 'Home', link: '/', onClick: () => navigate('/') },
      { name: 'About', link: '/aboutus', onClick: () => navigate('/aboutus') },
      {
        name: 'Gallery',
        link: '/gallery',
        children: [
          {
            name: 'Custom Built',
            link: '/gallery/custom-built',
            onClick: () => navigate('/comingsoon')
          },
          {
            name: 'Home Design',
            link: '/gallery/home-design',
            onClick: () => navigate('/comingsoon')
          },
          {
            name: 'Knockdown Rebuilt',
            link: '/gallery/knockdown-rebuilt',
            onClick: () => navigate('/comingsoon')
          },
          {
            name: 'Townhouses',
            link: '/gallery/townhouses',
            onClick: () => navigate('/comingsoon')
          }
        ]
      },
      { name: 'Contact', link: '/contact', onClick: () => navigate('/contact') }
    ]
  };

  const des = "Knockdown Rebuild Services"
  const Brand = "Aspire Homes"
  return (
    <>
      <Header {...headerConfig} />
      <ImageShow image="/images/app/contact.png" title="Knockdown Rebuilt " des={des} />
      <RightCard
        image="/images/app/desn01.png"
        header=" Why Choose Knockdown Rebuild?"
        description={
          <>
           Transform Your Property with Professional Knockdown Rebuild Solutions.Is your current home no longer meeting your family's needs? A knockdown rebuild offers the perfect opportunity to create your dream home on the land you love, without the hassle of relocating or the limitations of renovating an outdated structure.

          </>
        }
        description01={
          <>
           
              🏠 Keep Your Perfect Location: Stay in the neighborhood you love while creating a home that perfectly suits your lifestyle. No need to compromise on location when you can rebuild exactly where you want to be.
             
          </>
        }
        description02={
          <>
             💰 Cost-Effective Solution: Often more economical than extensive renovations, knockdown rebuild eliminates the uncertainty and hidden costs that come with working around existing structures.
          </>
        }
        description03={
          <>

              🎯 Complete Customization: Design your home from the ground up with modern layouts, energy-efficient systems, and contemporary features that reflect your personal style and functional needs.
          </>
        }
        description04={ 
          <>

              📐 Maximize Your Land: Take full advantage of your block's potential with optimal positioning, improved natural light, and better use of outdoor spaces.
          </>
        }
      />
      <LeftCard
        image="/images/app/assesment.png"
        header="1: Initial Consultation & Site Assessment"
        description={
          <>
            We evaluate your property, discuss your vision, and provide expert advice on design possibilities and council requirements.
          </>
        }
      />

      <RightCard
        image="/images/app/design.png"
        header="2. Design & Planning"
        description={
          <>
            Our experienced team works with you to create detailed plans that maximize your block's potential while staying within budget and timeline.

          </>
        }
      />

      <LeftCard
        image="/images/app/stretgy.png"
        header="3. Permits & Approvals"
        description={
          <>
           We handle all necessary council approvals, building permits, and compliance requirements, ensuring a smooth approval process.
          </>
        }
      />

      <RightCard
        image="/images/app/quality.png"
        header="4. Safe Demolition and Quality Construction"
        description={
          <>
          Professional demolition services with proper waste removal, utility disconnections, and site preparation for construction.
          </>
        }
        description01={
          <>
           Expert builders construct your new home using premium materials and modern building techniques, with regular progress updates throughout.

          </>
        }
      />

      <LeftCard
        image="/images/app/monitor.png"
        header="5. Final Handover"
        description={
          <>
            Complete quality inspections, final walk-through, and handover of your brand-new home with all warranties and documentation.
          </>
        }
      />
     <RightCard
        image="/images/app/quality.png"
        header="What Sets Us Apart"
        description={
          <>
          Local Expertise: Deep understanding of local council requirements and building codes.
          </>
        }
        description01={
          <>
           Full-Service Solution: From demolition to final handover, we manage every aspect.
          </>
        }
        description02={
          <>
          Quality Craftsmanship: Experienced tradespeople committed to exceptional standards
          </>
        }
        description03={
          <>
          Transparent Pricing: Clear, detailed quotes with no hidden surprises
          </>
        }
        description04={
          <>
          Timeline Commitment: Realistic schedules with regular progress communication
          </>
        }
        description05={
          <>
          After-Sales Support: Comprehensive warranties and ongoing maintenance support
          </>
        }
      />
       <LeftCard
        image="/images/app/monitor.png"
        header="Types of Properties We Rebuild"
        description={
          <>
           Family Homes: Spacious, functional designs perfect for growing families with modern living areas, multiple bedrooms, and outdoor entertainment spaces.
          </>
        }
        description01={
          <>
          Luxury Residences: High-end custom homes featuring premium finishes, smart home technology, and architectural excellence.
          </>
        }
        description02={
          <>
          Sustainable Builds: Environmentally conscious designs incorporating solar panels, energy-efficient systems, and sustainable materials.
          </>
        }
        description03={ 
          <>
          Compact Living: Clever, space-maximizing designs for smaller blocks that don't compromise on comfort or style
          </>
        }
        description04={
          <>
          Ready to Start Your Project: Contact us today for a free consultation and site assessment. Let's discuss how we can transform your property into the home you've always envisioned.
          </>
        }
      />
      <Testimonials id="testimonials" />
      <ContactUs id="contact" />
      <Footer />
    </>
  );

};


export default KnowBuild;
